var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "message-container d-flex justify-content-end mb-2 outbound",
    },
    [
      _vm.isSpecialMessage
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _vm.isPreserved
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        placement: "left",
                        content: "Message is preserved",
                      },
                    },
                    [_c("i", { staticClass: "fas fa-bookmark mr-1" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isGroupMessage
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        placement: "left",
                        content: "Group message",
                      },
                    },
                    [_c("i", { staticClass: "fas fa-users mr-1" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isCampaignMessage
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        placement: "left",
                        content: "Drip campaign message",
                      },
                    },
                    [_c("i", { staticClass: "fas fa-tint mr-1" })]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "message" }, [
        _c("div", { staticClass: "header text-right font-weight-bold" }, [
          _vm.outgoingNumberTitle
            ? _c("span", { staticClass: "outgoing-number-title" }, [
                _vm._v(_vm._s(_vm._f("uppercase")(_vm.outgoingNumberTitle))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "outgoing-number-phone-number" }, [
            _vm._v(_vm._s(_vm.outgoingNumberPhoneNumber)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content d-flex flex-column", style: _vm.styles },
          [
            _c(
              "div",
              { staticClass: "content-body w-100 d-flex" },
              [
                _c("div", { staticClass: "message-content w-100" }, [
                  _vm._v(_vm._s(_vm.content)),
                ]),
                _vm._v(" "),
                _c("message-settings", {
                  attrs: { settings: _vm.settings, message: _vm.message },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasMedia
              ? _c("media-list", {
                  attrs: { media: _vm.media, "is-inbound": false },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer text-right", class: _vm.statusClasses },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("uppercase")(_vm.statusString)) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logo ml-1" },
        [
          _c("el-image", {
            staticClass: "avatar",
            attrs: { src: _vm.logo, fit: "contain" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }